import React from 'react';
import { Button } from 'reactstrap';
import { TypedMemo } from '../../common/types';
import type { ShowcaseSignUpPlace } from './showcaseActions';
import { useRequiredMusicVideoShowcase } from './MusicVideoShowcaseContext';

interface ShowcaseSignUpLinkProps {
  place: ShowcaseSignUpPlace;
  children: React.ReactNode;
  className?: string;
}

/**
 * "Start free" and "Sign up free" of the showcase: a link to the sign-up with the intent
 * `music-video`. Inside the frame of music24.com it opens in the top window (`target="_top"`), so
 * the sign-up is a page of its own and not a page inside the frame.
 */
const ShowcaseSignUpLinkComponent: React.FC<ShowcaseSignUpLinkProps> = ({ place, children, className }) => {
  const { isEmbed, signUpHref, onSignUp } = useRequiredMusicVideoShowcase();
  return (
    <Button
      color="primary"
      size="sm"
      className={className}
      href={signUpHref}
      target={isEmbed ? '_top' : undefined}
      onClick={() => onSignUp(place)}
    >
      {children}
    </Button>
  );
};

export const ShowcaseSignUpLink = TypedMemo(ShowcaseSignUpLinkComponent);
